import React, { useContext } from "react";

import { useMutation } from "@apollo/client";
import { useFormikContext } from "formik";

import { marshalV2 } from "pages/eligibility/marshal";
import { SaveEligibilityFormProgress, SaveEligibilityFormProgressVariables } from "types/gql-types";

import saveFormProgress from "pages/eligibility/query/save-form-progress.gql";


import Context from "pages/eligibility/components/context/save-progress";
import formData from "pages/eligibility/components/context/form-data";
import { FormValues } from "pages/eligibility/type";

type SaveProgressProps = { submissionID: string, children?: React.ReactNode }

const SaveProgress = ({ submissionID, children }: SaveProgressProps): React.ReactElement => {
  const form = useContext(formData);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { questions } = form!;

  const { values } = useFormikContext();

  const [saveChanges] = useMutation<
  SaveEligibilityFormProgress,
  SaveEligibilityFormProgressVariables
  >(saveFormProgress);

  const onSaveProgress = () => {
    const answers = marshalV2(questions, values as FormValues[]);

    saveChanges({ variables: { submissionID, answers } });
  };

  return <Context.Provider value={onSaveProgress}>{children}</Context.Provider>;
};

export default SaveProgress;
